<template>
  <o-upload
    v-model="gpxFile"
    :loading="loading"
    :type="fileType"
    :label="uploadTextContent"
    @submit="submit"
    @deleteFile="deleteGpxFile"
  />
</template>

<script>
import OUpload from '@components/Upload.vue'

export default {
  name: 'LiveStageWaypointUpload',

  components: {
    OUpload,
  },

  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    stageWaypoints: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      gpxFile: null,
      fileType: 'application/gpx+xml',
    }
  },

  computed: {
    uploadTextContent() {
      return this.stageWaypoints.length === 0 ? 'Importer un GPX' : 'Remplacer le GPX'
    },
  },

  methods: {
    submit() {
      this.$emit('submit', this.gpxFile)
      this.deleteGpxFile()
    },

    deleteGpxFile() {
      this.gpxFile = null
    },
  },
}
</script>
